module.exports = __webpack_public_path__ + "static/media/3.1bc5c5c7.jpg";